// react-router-dom v6 has no SPA-navigation-aware pageview autocapture
// — PostHog's capture_pageview only fires once at initial script load.
// This hook fires a $pageview on every client-side route change,
// dropping the query string unconditionally so nothing in a URL
// param ever reaches PostHog as a side effect of this call.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capture } from "./posthog";

export function usePostHogPageview(): void {
  const location = useLocation();
  useEffect(() => {
    capture("$pageview", {
      $current_url: `${window.location.origin}${location.pathname}`,
    });
  }, [location.pathname]);
}
